import { POST } from '@/api'

/**
 * ぐるなび予約連携開始
 */
export default {
  namespaced: true,
  state: {
    busy: false,
  },
  mutations: {
    busy(state, busy) {
      state.busy = busy
    },
  },
  actions: {
    async save(store, { collaborationType, collaborationKey }) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/store/sync/gnavi/start', { collaborationType, collaborationKey })
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
